import React, { FC, useEffect, useState } from 'react';
import { ImageCropper } from './common/ImageCropper';
import { ModalWindow } from './modal/ModalWindow';
import { UploadLogo } from './developers/widget-configuration/UploadLogo';
import LogoPreview from './application/LogoPreview';
import { getCroppedImg } from '../utils/imageCrop';
import { Area } from 'react-easy-crop';
import { useTranslation } from 'react-i18next';


interface Props {
	formik: any,
	fieldName: string,
	label: string,
	uploadedFile: string,
	setUploadedFile: (value: string) => void,
	isEditMode: boolean
}
export const UploadImage: FC<Props> = (props) => {
	const { formik, fieldName, label, uploadedFile, setUploadedFile, isEditMode = true } = props;

	const { t } = useTranslation();

	const [selectedFile, setSelectedFile] = useState();
	const [preview, setPreview] = useState();
	const [pixelCrop, setPixelCrop] = useState<Area | undefined>();
	const [isDisable, setIsDisable] = useState<boolean>(false);
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const closeCropModal = (): void => setIsModalOpen(false);


	useEffect(() => {
		if (!selectedFile) {
			setPreview(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		// @ts-ignore
		setPreview(objectUrl);

		return (): void => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const onSelectFile = (e): void => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		const files = e.target.files;
		const reader = new FileReader();
		reader.readAsDataURL(files[0]);

		reader.onload = function (): any {
			formik.setFieldValue('LogoFile', reader.result);
			formik.setTouched({ 'LogoFile': true });
		};
		reader.onerror = function (): any {
			formik.setTouched({ 'LogoFile': true });
		};
		setIsModalOpen(true);
		setSelectedFile(files[0]);
	};

	const onEditFile = (): void => {
		if (preview) {
			setIsModalOpen(true);
		}
	};

	const onDeleteFile = (): void => {
		formik.setFieldValue(fieldName, '');
		setUploadedFile(undefined);
		setPreview(undefined);
	};

	const onModalSave = async (): Promise<void> => {
		try {
			const { file, fileURL } = await getCroppedImg({
        imageSrc: preview,
        pixelCrop
      });
			formik.setFieldValue(fieldName, file);
			setUploadedFile(fileURL);
			setIsDisable(true);
		} catch (e) {
			console.error(e);
		}
		setIsModalOpen(false);
	};

	return (
		<>

			{
				isEditMode
					? (
						<UploadLogo
							uploadedFile={uploadedFile}
							formik={formik}
							isDisable={isDisable}
							onDeleteFile={onDeleteFile}
							onSelectFile={onSelectFile}
							onEditFile={onEditFile}
							isAdmin={true}
							label={t(label)}
							fieldName={fieldName}
							additionalClass="col-6 col-sm-4 col-md-3"
							imageAdditionalClass="download-file-logo"
						/>
					)
					: (
						<LogoPreview
							uploadedFile={uploadedFile}
							label={t(label)}
						/>
					)
			}

			<ModalWindow
				isOpen={isModalOpen}
				modalTitle={t('COLOR_MODULE.CROP_TITLE')}
				confirmButtonText={t('COLOR_MODULE.SAVE')}
				onClose={closeCropModal}
				onCancel={closeCropModal}
				onConfirm={onModalSave}
				contentClassName="position-relative"
				content={
					<ImageCropper
						image={preview}
						setPixelCrop={setPixelCrop}
						aspect={34/ 10}
					/>
				}
			/>
		</>
	);
};